import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import * as moment from "moment";
import { FormBuilder, FormGroup } from "@angular/forms";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { GameSettingsService } from "@app/main/content/game-settings/game-settings.service";
import { AdminApi } from "@lbsdk/*";
import { environment } from "@env/environment";
import { SortablejsOptions } from "angular-sortablejs";
import * as _ from "lodash";
import { HelperService } from "@app/main/core/services/helper.service";

@Component({
  selector: "invite-image-art",
  templateUrl: "./invite-image-art.component.html",
  styleUrls: ["./invite-image-art.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class InviteImageArtComponent implements OnInit, OnChanges {
  inviteImageArtForm: FormGroup;
  @Input("editedGameId") editedGameId: any;
  @Input("logo") logo: any;
  @Input() gameId: string | null = null;
  @Input("data") data: any;
  @Input("expand") expand: boolean;
  @Input("gridType") gridType: any;
  @Input("emojis") emojis: any[];
  @Input("color1") color1: string = '#efeeee';
  @Input("color2") color2: string = '#efeeee';
  @Input("drawDate") drawDate: string = null;
  @Input("selectedId") selectedId: number = 0;
  @Input("inviteImageArtImage") inviteImageArtImage: any = null;
  @Input() gamePlayEmojiBackground: boolean = false;
  @Output() backgroundToggleChange = new EventEmitter<boolean>();
  @Input() layerUrl: string | null = null;
  @Input() layer: string | null = null;
  @Input() layerImageScale: number = 0;
  @Input() showInGameplay: boolean = false;
  @Output() showInGameplayChange = new EventEmitter<boolean>();
  @Input() isSwipeMenu: boolean = false;
  @Input() selectedEmojis: any[] = [{ image: '' }, { image: '' }, { image: '' }, { image: '' }, { image: '' }, { image: '' }];
  @Output() selectedEmojisChange = new EventEmitter<any[]>();

  @Input() gameFormat: string = "standard";
  @Input() dressUpFigure: string | null = null;
  @Input() dressUpFigureUrl: string | null = null;
  @Input() seatMapOpt: any = null;

  seatRows = [1, 2, 3, 4, 5, 6, 7, 8];
  leftSeatCols = ["A", "B", "C"];
  rightSeatCols = ["D", "E", "F"];

  // NEW: position toggle for the selected-emojis row (replaces power bar's old slot)
  @Input() gameplayEmojiPosition: string = 'top';
  @Output() gameplayEmojiPositionChange = new EventEmitter<string>();

  // NEW: LOGO upload control moved in from game-menu-art-preview
  @Output() logoStretchChange = new EventEmitter<boolean>();
  @Output() logoFileUpload = new EventEmitter<any>();
  @Output() logoRemoved = new EventEmitter<void>();

  private _surveyOnly: boolean;

  @Input()
  get surveyOnly() {
    return this._surveyOnly;
  }
  set surveyOnly(value: boolean) {
    this._surveyOnly = value;
    if (this.inviteImageArtForm) {
      this.inviteImageArtForm
        .get("surveyOnly")
        .setValue(value, { emitEvent: false });
    }
  }

  @Output() surveyOnlyChange = new EventEmitter<boolean>();

  @Output() inviteImageEvent = new EventEmitter<any>();

  min = new Date();

  selectedInviteImage: any;
  s3BucketUrl: string = "";
  inviteImageUrlPlaceHolder: any;
  inviteImageTimeoutPlaceholder = "";
  onErrorSrc = "/assets/images/image-not-found-150x150.png";

  emojisOptions: SortablejsOptions = {
    group: "normal-group",
  };

  resolvedDressUpFigure(): string {
    if (this.dressUpFigureUrl) return this.dressUpFigureUrl;
    if (this.dressUpFigure) return this.s3BucketUrl + this.dressUpFigure;
    return this.onErrorSrc;
  }

  getSeatIndex(rowIndex: number, colIndex: number): number {
    if (colIndex < 3) {
      return rowIndex * 3 + colIndex;
    } else {
      return 24 + rowIndex * 3 + (colIndex - 3);
    }
  }

  getSeatEmoji(rowIndex: number, colIndex: number): any {
    const idx = this.getSeatIndex(rowIndex, colIndex);
    return (this.emojis && this.emojis[idx]) ? this.emojis[idx] : null;
  }

  getSeatEmojiSrc(rowIndex: number, colIndex: number): string {
    const emoji = this.getSeatEmoji(rowIndex, colIndex);
    if (!emoji) return '';
    const img = emoji.image || (emoji.emoji && emoji.emoji.image) || '';
    if (!img) return '';
    return (img.startsWith('http') || img.startsWith('/assets') || img.startsWith('assets'))
      ? img
      : this.s3BucketUrl + img;
  }

  getSeatColor(rowIndex: number, colIndex: number): string {
    const unselectedColor = (this.seatMapOpt && this.seatMapOpt.unselectedFirstColor) || '#e5544a';
    const selectedColor = (this.seatMapOpt && this.seatMapOpt.selectedFirstColor) || '#3ddc61';
    const isSampleSelected = (rowIndex === 0 && colIndex === 0) || (rowIndex === 1 && colIndex === 5) || (rowIndex === 3 && colIndex === 2) || (rowIndex === 7 && colIndex === 3);
    return isSampleSelected ? selectedColor : unselectedColor;
  }

  onImgError(event: Event) {
    const img = event.target as HTMLImageElement;
    if (img.getAttribute("src") === this.onErrorSrc) return;
    img.src = this.onErrorSrc;
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _fuseSplashScreen: FuseSplashScreenService,
    private _gameSettingsService: GameSettingsService,
    private _adminApi: AdminApi,
  ) { }

  /**
   * life Cycle Methods
   */

  ngOnInit() {
    this.s3BucketUrl = environment.s3BucketUrl;

    this.data.isInviteImageArtGradient = false;

    if (!this.selectedInviteImage) {
      this.selectedInviteImage = 0;
      this.inviteImageUrlPlaceHolder =
        "Enter Reward " + (this.selectedInviteImage + 1) + " Url";
      this.inviteImageTimeoutPlaceholder =
        "Set Counter " + (this.selectedInviteImage + 1);
    }
    this.inviteImageArtForm = this.createInviteImageArtForm();

    this.inviteImageArtForm
      .get("surveyOnly")
      .valueChanges.subscribe((value) => {
        this.surveyOnly = value;
        this.surveyOnlyChange.emit(value);
      });

    this.inviteImageArtForm
      .get("inviteExpirationTime")
      .valueChanges.subscribe((value) => {
        // this.onChangeInviteExpirationTime(value);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.s3BucketUrl = environment.s3BucketUrl;
    if (changes.emojis) {
      this.emojis = changes.emojis.currentValue;
    }
    if (changes.data) {
      this.data = changes.data.currentValue;
      this.data.invitesData.powerBar.image =
        this.data.invitesData.powerBar.image.replace(this.s3BucketUrl, "");
      this.data.invitesData.powerBar.audio =
        this.data.invitesData.powerBar.audio.replace(this.s3BucketUrl, "");
    }
    if (changes.logo) {
      this.logo = changes.logo.currentValue;
      if (this.logo && this.logo.replace(this.s3BucketUrl, "")) {
        this.logo = this.logo.replace(this.s3BucketUrl, "");
      }
    }
    if (changes.color1 && changes.color1.currentValue !== "") {
      this.data.isInviteImageArtGradient = true;
      this.color1 = changes.color1.currentValue;
    }
    if (changes.color2 && changes.color2.currentValue !== "") {
      this.data.isInviteImageArtGradient = true;
      this.color2 = changes.color2.currentValue;
    }
  }

  /**
   * Public Methods
   */

  createInviteImageArtForm() {
    this.selectedInviteImage = this.selectedInviteImage
      ? this.selectedInviteImage
      : 0;
    return this._formBuilder.group({
      inviteImageUrl: [
        this.data.invitesData.invites[this.selectedInviteImage].inviteImageUrl,
      ],
      inviteExpirationTime: [
        this.data.invitesData.invites[this.selectedInviteImage]
          .inviteExpirationTime,
      ],
      surveyOnly: [this.surveyOnly],
    });
  }

  onBackgroundToggleChange(event: any) {
    this.gamePlayEmojiBackground  = event.checked;
    this.backgroundToggleChange.emit(this.gamePlayEmojiBackground );
  }

  onSelectedEmojiUpload($event, index) {
    if ($event.target.files.length) {
      this._fuseSplashScreen.show();
      this._gameSettingsService
        .upload(
          $event,
          this._gameSettingsService.inviteImageArtUploadPath,
          this._adminApi.getCurrentToken().id
        )
        .then((response: any) => {
          const imageName = response.result.files["file"][0]["providerResponse"].name;
          if (!this.selectedEmojis || this.selectedEmojis.length !== 6) {
            this.selectedEmojis = [{ image: '' }, { image: '' }, { image: '' }, { image: '' }, { image: '' }, { image: '' }];
          }
          this.selectedEmojis[index] = { image: imageName };
          this.selectedEmojisChange.emit(this.selectedEmojis);
          this._fuseSplashScreen.hide();
        })
        .catch((error) => {
          console.error("Error uploading selected emoji image:", error);
          this._fuseSplashScreen.hide();
        });
    }
  }

  onGameplayEmojiPositionToggle() {
    this.gameplayEmojiPosition = this.gameplayEmojiPosition === 'top' ? 'bottom' : 'top';
    this.gameplayEmojiPositionChange.emit(this.gameplayEmojiPosition);
  }

  powerBarUpload = ($event) => {
    if ($event.target.files.length) {
      this._fuseSplashScreen.show();

      // Upload directly without compression
      this._gameSettingsService
        .upload(
          $event,
          this._gameSettingsService.powerBarUploadPath,
          this._adminApi.getCurrentToken().id
        )
        .then((response: any) => {
          // Update the image properties
          this.data.invitesData.powerBar.image =
            response.result.files["file"][0]["providerResponse"].name;
          this.saveInLocalStorage(
            "powerBar",
            JSON.stringify(this.data.invitesData.powerBar)
          );
          this.sendInviteImageData();
          this._gameSettingsService.isDuplicationFlag = true;
          this._fuseSplashScreen.hide();
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
          this._fuseSplashScreen.hide();
        });
    }
  };

  powerBarAudioUpload($event) {
    if ($event.target.files.length) {
      this._fuseSplashScreen.show();
      this._gameSettingsService
        .uploadSound(
          $event,
          this._gameSettingsService.powerBarAudioUploadPath,
          this._adminApi.getCurrentToken().id
        )
        .then(
          (response: any) => {
            this.data.invitesData.powerBar.audio =
              response.result.files["file"][0]["providerResponse"].name;
            this.saveInLocalStorage(
              "powerBar",
              JSON.stringify(this.data.invitesData.powerBar)
            );
            this.sendInviteImageData();
            this._gameSettingsService.isDuplicationFlag = true;
            this._fuseSplashScreen.hide();
          },
          (error) => {
            this._fuseSplashScreen.hide();
          }
        );
    }
  }

  saveInLocalStorage(key, value) {
    if (_.isUndefined(this._gameSettingsService.routeParams.id)) {
      localStorage.setItem(key, value);
    }
  }

  sendInviteImageData() {
    this.inviteImageEvent.emit(this.data);
  }

  isExpand(type, $event) {
    this.data.invitesData.powerBar.isExpand = $event.checked;
    this._gameSettingsService.isDuplicationFlag = true;
    this.saveInLocalStorage(
      "powerBar",
      JSON.stringify(this.data.invitesData.powerBar)
    );
  }

  onChangeInviteUrl($event): void {
    this.selectedInviteImage = this.selectedInviteImage
      ? this.selectedInviteImage
      : 0;
    this.data.invitesData.invites[this.selectedInviteImage].inviteImageUrl =
      $event;
    this.saveInLocalStorage(
      "invites",
      JSON.stringify(this.data.invitesData.invites)
    );
  }

  updateDates(value: Date) {
    // Extract date part from drawDate
    const drawDateMoment = moment(this.drawDate);
    const drawDatePart = drawDateMoment.format("YYYY-MM-DD");

    // Extract time part from value
    const valueMoment = moment(value);
    const valueTimePart = valueMoment
      .seconds(0)
      .milliseconds(0)
      .format("HH:mm:ss.SSS");

    // Combine date part from drawDate with time part from value
    const newDateTimeString = `${drawDatePart}T${valueTimePart}Z`;

    // Log the updated value with the new combined date and time
    return newDateTimeString;
  }

  onChangeInviteExpirationTime(value): void {
    if (!value) return;
    this.sendInviteImageData();
    this.updateDates(value);
    const inviteExpirationTime = this.inviteImageArtForm.get("inviteExpirationTime");
    const newValue = this.updateDates(value);
    if (moment(newValue).isAfter(moment(this.drawDate))) {
      this.selectedInviteImage = this.selectedInviteImage
        ? this.selectedInviteImage
        : 0;
      this.data.invitesData.invites[
        this.selectedInviteImage
      ].inviteExpirationTime = value;
      this.saveInLocalStorage(
        "invites",
        JSON.stringify(this.data.invitesData.invites)
      );
      inviteExpirationTime.setErrors(null); // Setting validity to true

    } else {
      inviteExpirationTime.setErrors({ invalidDate: true });
      this.sendInviteImageData();
    }

  }

  getImageSrc(item) {
    if (!item) return "";
    const rawImage = item.image || (item.emoji && item.emoji.image) || "";
    return rawImage
      ? this.s3BucketUrl + rawImage.replace(this.s3BucketUrl, "")
      : "";
  }

  onGradientCheckbox() {
    this.data.isInviteImageArtGradient = !this.data.isInviteImageArtGradient;
    this.data.invitesData.isInviteImageArtGradient =
      !this.data.invitesData.isInviteImageArtGradient;
    localStorage.setItem(
      "isInviteImageArtGradient",
      JSON.stringify(this.data.isInviteImageArtGradient)
    );
    this.sendInviteImageData();
  }

  onProgressBarTransparentCheckbox() {
    this.data.isProgressBarTransparent = !this.data.isProgressBarTransparent;
    this.data.invitesData.isProgressBarTransparent =
      !this.data.invitesData.isProgressBarTransparent;
    localStorage.setItem(
      "isProgressBarTransparent",
      JSON.stringify(this.data.isProgressBarTransparent)
    );
    this.sendInviteImageData();
  }

  onShowInGameplayCheckbox() {
    this.showInGameplay = !this.showInGameplay;
    localStorage.setItem(
      "showInGameplay",
      JSON.stringify(this.showInGameplay)
    );
    // EMIT BACK TO PARENT
    this.showInGameplayChange.emit(this.showInGameplay);
  }

  updateInviteImageId(selectedId) {
    this.selectedId = selectedId;
    this.selectedInviteImage = selectedId;
    this.inviteImageUrlPlaceHolder =
      "Enter Reward " + (this.selectedInviteImage + 1) + " Url";
    this.inviteImageTimeoutPlaceholder =
      "Set Counter " + (this.selectedInviteImage + 1);
    this.inviteImageArtForm = this.createInviteImageArtForm();
  }

  getMenuLayerImage(): string | null {
    if (this.gameId && this.layer) {
      return this.s3BucketUrl + this.layer;
    }
    return this.layerUrl;
  }

  inviteImageArtIsExpand($event) {
    this.data.invitesData.invites[this.selectedId].isExpand = $event.checked;
    this.saveInLocalStorage("invites", this.data.invitesData.invites);
  }

  imageUpload($event, type) {
    if ($event.target.files.length) {
      this._fuseSplashScreen.show();

      // Upload directly without compression
      this._gameSettingsService
        .upload(
          $event,
          this._gameSettingsService[`${type}UploadPath`],
          this._adminApi.getCurrentToken().id
        )
        .then((response: any) => {
          const imageName =
            response.result.files["file"][0]["providerResponse"].name;
          // Handle different types
          if (type === "inviteImageArt") {
            this.data.invitesData.invites[this.selectedId].image = imageName;
            this.saveInLocalStorage(
              "invites",
              this.data.invitesData.invites
            );
          }

          this._fuseSplashScreen.hide();
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
          this._fuseSplashScreen.hide();
        });
    }
  }
}
